<ng-template #loading>
  <i class="fal fa-spinner-third fa-spin"></i>
</ng-template>

<mat-list-item *ngIf="tag; else loading">
  <ng-container>
    <div class="col__">
      <div mat-line
           class="d-flex flexAlign--center mb-0050">
        <mat-icon mat-list-icon
                  fontSet="fal"
                  [fontIcon]="tagIcon"
                  class="color--turq txt-14"
                  style="height: auto;">
        </mat-icon>
        <div class="txt-14 truncate truncate--type-tag">
          <span *ngIf="tag.targetType?.__typename === 'EntityType'">
            {{tag.targetType.namePlural | propercase}}
          </span>
          <app-connection-type-name [connectionType]="tag.targetType"
                                    *ngIf="tag.targetType?.__typename === 'EntityConnectionType'">
          </app-connection-type-name>
          &rsaquo;
          <ng-container >
            <i class="fal fa-solar-system color--purple"
               matTooltip="This is a universal field; responses belonging to this field are available across all campaigns for which this field is enabled."
               *ngIf="tag.isUniversal"></i>
          </ng-container>
          {{tag.category?.name}}
        </div>
        <button mat-icon-button
                [disabledRipple]="true"
                (click)="onRemoveTagClicked(tag)"
                aria-label="Remove response"
                class="remove-item"
                style="top: -4px; right:0">
          <mat-icon fontSet="far"
                    fontIcon="fa-times"></mat-icon>
        </button>
      </div>
      <div class="d-flex flexAlign--end flexJustify--between pr-0025"
           [ngClass]="{'color--gray--007': tag.archived}">
        <strong class="d-block truncate txt-16">{{tag.name}}
          <span *ngIf="tag.archived">[Archived]</span>
        </strong>
        <ng-content select="[addLink]"></ng-content>
      </div>
      <div mat-line>
        <ng-content select="[addContents]"></ng-content>
      </div>
      <div mat-line>
        <ng-content select="[addAttachment]"
                    *ngIf="tag?.category?.attachmentsEnabled"></ng-content>
      </div>
    </div>
  </ng-container>

  <div mat-line>
    <ng-content></ng-content>
    <!-- HACK: Need to only show this content
         when the resolved tag allows an attachment.

        -->
    <ng-content select="[addAttachment]"
                *ngIf="tag?.category?.attachmentsEnabled"></ng-content>
  </div>
</mat-list-item>
